import React from 'react';
import * as PropTypes from 'prop-types';

import './KBCategoryPage.scss';
import { classNamer, capitalizeFirstLetter, classes } from '../../lib/utils';
import R from '../../lib/routes';
import Navigation from '../widgets/Navigation';
import { Link } from '../../router';
import Layout from '../layout/Layout';
import KBArticlesList from './KBArticlesList';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { createFrontendPageUrl, resolveStrapiImage } from '../../lib/selectors';
import i18n from '../../translations/i18n';

const cn = classNamer('KBCategoryPage');

class KBCategoryPage extends React.PureComponent {
  replaceFieldsForNavigation(category) {
    if (!category) return category;
    return {
      ...category,
      title: capitalizeFirstLetter(category.name),
      name: capitalizeFirstLetter(category.title),
    };
  }

  render() {
    const { articles, next, prev, category, ...passProps } = this.props;

    const newNext = this.replaceFieldsForNavigation(next);
    const newPrev = this.replaceFieldsForNavigation(prev);

    const topArticleNavigation = (
      <Navigation prev={newPrev} next={newNext} dynamicRoute={R.kbCategoryBySlug}>
        <Link href={R.knowledgeBase}>
          <a>{i18n.knowledgeBase}</a>
        </Link>
      </Navigation>
    );

    const seoTitle =
      (category && Object.keys(category).length && category.name) || i18n.kbPageSEOTitle;
    const seoDescription =
      (category && Object.keys(category).length && category.title) || i18n.kbPageSEODescription;

    return (
      <>
        <Head>
          <meta name="description" content={seoDescription} key="description" />
          <title>{seoTitle}</title>
        </Head>
        <NextSeo
          openGraph={{
            url: createFrontendPageUrl(R.kbCategoryBySlug(category)),
            locale: 'en_US',
            title: seoTitle,
            description: seoDescription,
            type: 'website',
            images: [
              resolveStrapiImage(
                category && Object.keys(category).length && category.category_image
              ),
            ],
            site_name: i18n.kbpageSiteName,
          }}
        />
        <Layout className={cn()} {...passProps} currentPageComponent={topArticleNavigation}>
          <div className={classes('container')}>
            <div className="row">
              <div className="col-12">
                {topArticleNavigation}
                <h1 className={cn('title')}>{capitalizeFirstLetter(category.name)}</h1>
                <p className={cn('subtitle')}>{category.title}</p>
                <KBArticlesList articles={this.props.articles} />
                <Navigation prev={newPrev} next={newNext} dynamicRoute={R.kbCategoryBySlug}>
                  <a href="#top" title="Back to top">
                    {i18n.backToTop}
                  </a>
                </Navigation>
              </div>
            </div>
          </div>
        </Layout>
      </>
    );
  }
}

KBCategoryPage.propTypes = {
  articles: PropTypes.array,
  category: PropTypes.object,
};

export default KBCategoryPage;
